// extracted by mini-css-extract-plugin
export default {"tags":"Tags_tags__j3G+c","tags_wrap":"Tags_tags_wrap__EdmDs","tags_header":"Tags_tags_header__YS5Zf"};